import type { FilterGroup } from '@app/src/pages/ResourceCollection/Filters/useFilters'

/** A field on the provider as the collection reaches it: '' when the row is the provider itself. */
export const withProviderPath = (providerPath: string, path: string): string =>
  providerPath ? `${providerPath}.${path}` : path

/** Filter groups on the provider, as the collection reaches it. */
export const groupsWithProviderPath = (providerPath: string, groups: FilterGroup[]): FilterGroup[] =>
  groups.map(group => ({ ...group, name: withProviderPath(providerPath, group.name) }))
